export const LandingPage = (): JSX.Element => {
    return <div>Landing Pages</div>;
};
